/** Build information injected by vite.config.ts (see `define`). */
export const appVersion = {
  version: __APP_VERSION__,
  commit: __APP_COMMIT__,
  buildDate: __APP_BUILD_DATE__,
};
